jQuery(document).ready(function ($) {
  var $box_carousel_testimony = $(".box-carousel.carousel-testimony .swiper");

  if (!$box_carousel_testimony.length) return;

  $box_carousel_testimony.each(function (index, element) {
    var mySwiper = new Swiper(element, {
      autoplay: {
        delay: 7000,
        // disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 400,
      navigation: {
        nextEl: $(element).parent().find(".carousel-navigation.next")[0],
        prevEl: $(element).parent().find(".carousel-navigation.prev")[0],
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });
});
